import { MatDialogConfig } from '@angular/material/dialog';
import { DeletePurchaseNoteDialogData } from './dialog-delete-np.component';

export const DELETE_PURCHASE_NOTE_PANEL_CLASS = 'create-order-panel';

export function buildDeletePurchaseNoteDialogConfig(
  data: DeletePurchaseNoteDialogData,
  options?: { disableClose?: boolean }
): MatDialogConfig<DeletePurchaseNoteDialogData> {
  return {
    width: '480px',
    maxWidth: '94vw',
    panelClass: DELETE_PURCHASE_NOTE_PANEL_CLASS,
    autoFocus: false,
    disableClose: options?.disableClose ?? false,
    data
  };
}
